export const UserGuideStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
} as const

export type UserGuideStatus = keyof typeof UserGuideStatus

export const UserGuideTrigger = {
  MANUAL: 'MANUAL',
  FIRST_VISIT: 'FIRST_VISIT',
  FIRST_VISIT_AND_MANUAL: 'FIRST_VISIT_AND_MANUAL',
} as const

export type UserGuideTrigger = keyof typeof UserGuideTrigger

export const UserGuideSelectorType = {
  DATA_ATTR: 'DATA_ATTR',
  ID: 'ID',
  CSS_PATH: 'CSS_PATH',
} as const

export type UserGuideSelectorType = keyof typeof UserGuideSelectorType

export const USER_GUIDE_STATUS_LABELS: Record<UserGuideStatus, string> = {
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
  ARCHIVED: 'Archived',
}

export const USER_GUIDE_TRIGGER_LABELS: Record<UserGuideTrigger, string> = {
  MANUAL: 'Manual only',
  FIRST_VISIT: 'First visit',
  FIRST_VISIT_AND_MANUAL: 'First visit and manual',
}

export function normalizeClientRoutePath(path: string): string {
  const withoutQuery = path.split('?')[0]?.split('#')[0] ?? '/'
  const withSlash = withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`
  return withSlash.replace(/\/+$/, '') || '/'
}

export function matchRoutePattern(pattern: string, pathname: string): boolean {
  const patternParts = normalizeClientRoutePath(pattern).split('/').filter(Boolean)
  const pathParts = normalizeClientRoutePath(pathname).split('/').filter(Boolean)
  const splatAt = patternParts.indexOf('*')
  if (splatAt !== -1) {
    if (splatAt !== patternParts.length - 1) return false
    const prefix = patternParts.slice(0, -1)
    if (pathParts.length < prefix.length) return false
    return prefix.every((segment, index) => segment.startsWith(':') || segment === pathParts[index])
  }
  if (patternParts.length !== pathParts.length) return false
  return patternParts.every((segment, index) => segment.startsWith(':') || segment === pathParts[index])
}

export function inferSelectorType(selector: string): UserGuideSelectorType {
  if (selector.startsWith('[data-guide-id')) return UserGuideSelectorType.DATA_ATTR
  if (selector.startsWith('#')) return UserGuideSelectorType.ID
  return UserGuideSelectorType.CSS_PATH
}
